import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';

export type FamilyMember = {
  id: string;
  email: string;
  role: string;
  is_verified: boolean;
  first_name: string | null;
  last_name: string | null;
  gender: string | null;
  phone_number: string | null;
  city_town: string | null;
  postcode: string | null;
  created_at: string;
};

const useAdminFamilies = () => {
  const queryFn = async (): Promise<FamilyMember[]> => {
    const { data, error } = await supabaseClient
      .from('users')
      .select('*')
      .eq('role', 'family_member')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching family members:', error);
      throw new Error(error.message);
    }

    return data || [];
  };

  return useQuery<FamilyMember[], Error>({
    queryKey: ['admin-families'],
    queryFn,
  });
};

export default useAdminFamilies;
